<template>
  <div class="departmentRemark" v-if="isShow" :style="`zIndex:${zIndex}`">
    <div class="componentclose"
         @click="isShow=false">X</div>
    <ul>
      <li class="ochart-select">
        <el-select v-model="character"
                   filterable
                   placeholder="部门角色"
                   size="mini">
          <el-option v-for="item in tabletype"
                     :key="item"
                     :label="item"
                     :value="item">
          </el-option>
        </el-select>
        <el-select v-model="choosemember"
                   placeholder="候选人"
                   filterable
                   remote
                   style="margin:0 35px;"
                   :remote-method="serchmembers"
                   size="mini">
          <el-option v-for="item in members"
                     :key="item._id"
                     :label="item.姓名"
                     :value="item.姓名">
          </el-option>
        </el-select>
        <el-button size="mini" type="primary" @click="addRow">添加</el-button>
      </li>
      <li>
        <table>
          <thead>
            <td style="width:70px">部门角色</td>
            <td style="width:70px">管理职级</td>
            <td style="width:70px">专业职级</td>
            <td style="width:70px">目前职位</td>
            <td style="width:70px">人选</td>
            <td style="width:70px">口碑评价</td>
            <td style="width:80px">操作</td>
          </thead>
          <tbody>
            <tr v-for='(item,index) in table'
                :key="index+2">
              <td style="width:70px">
                <el-select v-model="item.部门角色"
                           size='mini'>
                  <el-option v-for="item in ['A角','B角']"
                             :key="item"
                             :label="item"
                             :value="item">
                  </el-option>
                </el-select>
              </td>
              <td style="width:70px">
                <el-select v-model="item.管理职级"
                           filterable
                           size='mini'>
                  <el-option v-for="item in tabletype2"
                             :key="item"
                             :label="item"
                             :value="item">
                  </el-option>
                </el-select>
              </td>
              <td style="width:70px">
                <el-select v-model="item.专业职级"
                           filterable
                           size='mini'>
                  <el-option v-for="item in tabletype1"
                             :key="item"
                             :label="item"
                             :value="item">
                  </el-option>
                </el-select>
              </td>
              <td style="width:70px">
                <el-input v-model="item.目前职位" size='mini'></el-input>
              </td>
              <td style="width:70px">
                <span>{{item.人选}}</span>
              </td>
              <td style="width:70px">
                <i class="el-icon-star-on"
                   style='color:#f7ba2a;'
                   @click="_showscore(item)"></i>
                <span>{{item.评价}}</span>
              </td>
              <td style="width:80px">
                <el-button type="text" style="color:#f56c6c" @click="removeRow(item)">删除</el-button>
                <el-button type="text" @click="saveRow(item)">保存</el-button>
              </td>
            </tr>
          </tbody>
        </table>
      </li>
    </ul>
  </div>
</template>
<script>
import * as fixedvariant from '../../statistics/variant/fixedvariant.js'
export default {
  data() {
    return {
      isShow: false,
      department: '',
      character: '',
      tabletype: fixedvariant.部门角色,
      choosemember: '',
      members: [],
      tempMemberArr: [],
      table: [],
      tabletype1: JSON.parse(JSON.stringify(fixedvariant.专业职级表头)),
      tabletype2: JSON.parse(JSON.stringify(fixedvariant.管理职级表头)),
      departmentRemark: '',
      departmentRemarkDrag: false,
      departmentId: '',
      zIndex: '',
    }
  },
  methods: {
    async open(data) {
      this.department = data
      this.loadData()
      this.tempMemberArr = await app.service('company').getDepartmentMember(this.department)
      this.members = this.tempMemberArr

      this.$nextTick(() => {
        this.domdrag()
      })
      this.isShow = true
      this.zIndex = app.root.dragindex++
    },
    async loadData() {
      const res = await app.service('company').getDepartmentCharacter({ _id: this.department._id })
      this.table = res.data
    },
    domdrag() {
      let startX, startY, clientX, clientY
      let dom
      let isDrag = false
      document.addEventListener('mousedown', e => {
        if (typeof e.target.className!=="object"&&e.target.className.indexOf('departmentRemark') !== -1) {
          e.preventDefault()
          dom = e.target
          dom.style.zIndex = app.root.dragindex++
          startX = dom.offsetLeft
          startY = dom.offsetTop
          clientX = e.clientX
          clientY = e.clientY
          isDrag = true
        }
      })
      document.addEventListener('mousemove', e => {
        if (isDrag) {
          e.preventDefault()
          dom.style.left = e.clientX - clientX + startX + 'px'
          dom.style.top = e.clientY - clientY + startY + 'px'
        }
      })
      document.addEventListener('mouseup', e => {
        if (isDrag) isDrag = false
      })
    },
    async serchmembers(val) {
      if (val !== '') {
        this.members = await app.service('company').serchDepartmentMember({ 公司: this.department.公司, 姓名: val })
      } else {
        this.members = this.tempMemberArr
      }
    },
    async addRow() {
      if (this.character === '') this.$message('请选择部门角色')
      else if (this.choosemember === '') this.$message('请选择候选人')
      else this.checkA()
    },
    async insertOchartTable() {
      let radish = this.members.find(val => val.姓名 == this.choosemember)
      let result = await app.service('company').insertOchartTable({
        department: this.department,
        radish: radish,
        character: this.character,
      })
      if (result.status === 'success') {
        this.loadData()
        this.$emit('refreshTable')
      } else this.$message(result.msg)
    },
    checkA() {
      const a = this.table.find(val => val.部门角色 === 'A角')
      if (this.character === 'A角' && a) {
        this.$alert(`该部门已存在A角（${a.姓名 || a.人选}），是否替换`, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
          .then(() => {
            this.insertOchartTable()
            this.initchoosecharacter()
          })
          .catch(() => {
            this.$message.info('已取消')
            this.initchoosecharacter()
          })
      } else {
        this.insertOchartTable()
        this.initchoosecharacter()
      }
      this.loadData()
    },
    initchoosecharacter() {
      this.character = ''
      this.choosemember = ''
    },
    async removeRow(radish) {
      let result = await app.service('company').deleteOchartTable({
        department: this.department,
        radish: radish,
      })
      if (result.status === 'success') {
        this.loadData()
        this.$emit('refreshTable')
      } else this.$message(result.msg)
    },
    async _showscore(val) {
      app.root.$refs.radishScore.open(val._id || val.rid)
    },
    async saveRow(radish) {
      let result = await app.service('company').updateDepartmentTable({
        department: this.department,
        radish: radish,
      })
      if (result.status === 'success' || result.status === 200) {
        this.loadData()
        this.$emit('refreshTable')
      } else this.$message(result.msg)
    },
  },
}
</script>
<style>
.departmentRemark tbody .el-input .el-input__inner {
  border-color: transparent;
}
</style>
<style  scoped>
* {
  box-sizing: border-box;
  margin: 0;
}

ul {
  padding: 0;
  overflow: hidden;
  list-style: none;
}

table {
  margin: 10px auto 0;
  text-align: center;
  border-collapse: collapse;
  border-top: 1px solid #e1e0e0;
  border-left: 1px solid #e1e0e0;
}

td {
  display: inline-block;
  height: 30px;
  line-height: 30px;
  border-right: 1px solid #e1e0e0;
  border-bottom: 1px solid #e1e0e0;
}

.departmentRemark {
  position: fixed;
  top: 110px;
  left: calc(50vw - 350px);
  z-index: 1001;
  width: 700px;
  max-height: calc(100vh - 50px);
  padding: 22px;
  margin: auto;
  overflow: auto;
  background-color: #fff;
  border: 1px solid #eaeefb;
  border-radius: 5px;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
  transition: all 0.2s ease-in-out;
}

.ochart-select {
  display: flex;
  justify-content: center;
}

.componentclose {
  position: absolute;
  top: 15px;
  right: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  background-color: #e83939;
  border-radius: 50%;
}
</style>
